import { Accordion, Flowbite } from 'flowbite-react';
import propTypes from 'prop-types'
import { customTheme } from '../../../theme/flowbite';
import { ChevronDownArrow } from '../../../theme/icons';

export const AccordionComponent = ({ collapseAll, steps, }) => {
    return (<>
        {!!steps?.length && <Flowbite theme={{ theme: customTheme }}><Accordion collapseAll={collapseAll}
            arrowIcon={ChevronDownArrow}
            className='custom-accordion'>
            {steps?.map((step, i) => <Accordion.Panel key={i + 1}>
                <Accordion.Title className='w-full'>
                    {step?.title}
                </Accordion.Title>
                <Accordion.Content className='p-5 bg-white'>
                    {step?.content}
                </Accordion.Content>
            </Accordion.Panel>)}
        </Accordion></Flowbite>}</>
    )
}

AccordionComponent.propTypes = {
    steps: propTypes.array,
    collapseAll: propTypes.bool,
    loader: propTypes.bool,

}

AccordionComponent.defaultProps = {
    steps: [
        {
            title: <> What is Flowbite?</>,
            content: <>
                <p className="mb-2 text-gray-500 dark:text-gray-400">
                    <p>
                        Flowbite is an open-source library of interactive components built on top of Tailwind CSS including buttons,
                        dropdowns, modals, navbars, and more.
                    </p>
                </p>
                <p className="text-gray-500 dark:text-gray-400">
                    <p> Check out this guide to learn how to </p>
                    <a
                        className="text-cyan-600 hover:underline dark:text-cyan-500"
                        href="https://flowbite.com/docs/getting-started/introduction/">
                        <p> get started </p>
                    </a>
                    <p> and start developing websites even faster with components on top of Tailwind CSS. </p>
                </p>
            </>
        }
    ],
    collapseAll: false,
    loader: false,

}

